<template>
    <div>

        <v-form v-model="valid" ref="formData">

            <v-dialog v-model="dialogPayment" persistent width="50%">
                <v-overlay :value="overlay">
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>

                <v-card>
                    <v-card-title>
                        <span>{{ $t("payment") }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            text
                            icon
                            @click="handleClose"
                            valid="false"
                            v-shortkey="['esc']"
                            @shortkey.native="handleClose"
                        >
                            <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="seperate-line-verticle">

                                <v-row style="padding-right: 10px">

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.from_contact_name"
                                            outlined
                                            :dense="dense"
                                            :label="$t('paidPayment') + '*'"
                                            disabled
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.to_contact_name"
                                            outlined
                                            :dense="dense"
                                            :label="$t('receiverPayment') + '*'"
                                            disabled
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-select
                                            v-model="formPayment.currency_code"
                                            :items="currencyOptionList"
                                            disabled
                                            :label="$t('currency')"
                                            outlined
                                            item-text="text"
                                            item-value="id"
                                            dense
                                        ></v-select>
                                    </v-col>

                                     <!-- <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px; padding-top: 5px">
                                        <v-select
                                            :items="paymentMethod"
                                            :label="$t('paymentMethod')"
                                            outlined
                                            v-model="formPayment.payment_method"
                                            dense
                                            disabled
                                        >
                                            <template v-slot:selection="{ item }">{{ $t(item) }}</template>
                                            <template v-slot:item="{ item }">{{ $t(item) }}</template>
                                        </v-select>
                                    </v-col> -->

                                    <v-col cols="12" sm="12" md="12">
                                        <v-select
                                            :items="customerWallet"
                                            :label="$t('wallet') + '*'"
                                            outlined
                                            v-model="formPayment.wallet_account"
                                            :rules="selectRules"
                                            item-text="account_type_name"
                                            item-value="account_type_name"
                                            dense
                                            required
                                        >
                                            <template v-slot:selection="{item}">
                                                {{$t(item.account_type_name) }} : {{ item.available_balance |
                                                formatNumber}} {{currency_symbol}}
                                            </template>
                                            <template v-slot:item="{item}">
                                                {{ $t(item.account_type_name) }} : {{ item.available_balance |
                                                formatNumber}} {{currency_symbol}}
                                            </template>
                                        </v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-menu
                                            v-model="menuDate"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="formPayment.date"
                                                    :label="$t('receivePaymentDate') + '*'"
                                                    prepend-inner-icon="mdi-calendar"
                                                    outlined
                                                    dense
                                                    readonly
                                                    :rules="dateRules"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                :first-day-of-week="0"
                                                v-model="formPayment.date"
                                                :rules="dateRules"
                                                @input="menuDate = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="formPayment.reference"
                                            outlined
                                            dense
                                            :label="$t('reference')"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-row>
                                    <!-- <v-col cols="5" sm="5">{{ $t("step") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formPayment.step}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("duration") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ formPayment.duration }} {{ $t(formPayment.duration_type.split("_")[1])}}</span></v-col> -->

                                    <v-col cols="5" sm="5">{{ $t("totalAmount") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.total_amount | formatNumber}} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("paid") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.complete_paid | formatNumber }} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("partial") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ +formPayment.total_payment | formatNumber }} {{getCurrencySymbol(formPayment.currency_code)}}</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("percentage") }}</v-col>
                                    <v-col cols="7" sm="7"> : <span style="font-weight: bold;font-size: 20px">{{ calculatePercentage }}%</span></v-col>
                                    <v-col cols="5" sm="5">{{ $t("paidAmount") }}</v-col>
                                    <v-col cols="7" sm="7">
                                        <v-text-field
                                            v-model="formPayment.paid_amount"
                                            outlined
                                            dense
                                            :max="formPayment.total_payment"
                                            min="1"
                                            style="margin-bottom: -10px"
                                            required
                                            :rules="requireAndNumberAtleaseOne"
                                            >
                                        </v-text-field>
                                        <span v-show="! this.valid_paid" class="error--text">{{ $t('maximum') + ' ' + formPayment.total_payment }} </span>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea
                                            clearable
                                            outlined
                                            :placeholder="$t('yourDesc')"
                                            v-model="formPayment.note"
                                            clear-icon="mdi-close-circle"
                                            rows="3"
                                            auto-grow
                                            :label="$t('note')"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            rounded
                            @click="submitPayment($event,true)"
                            style="min-width: 150px"
                            color="primary"
                            :disabled="! this.valid_paid"
                        >
                            <font-awesome-icon
                                icon="check-circle"
                                style="margin-right: 10px"
                            />
                            {{$t("payAndPrint")}}
                        </v-btn>
                        <v-btn
                            rounded
                            @click="submitPayment($event)"
                            style="min-width: 150px"
                            color="success"
                            :disabled="! this.valid_paid"
                        >
                            <font-awesome-icon
                                icon="check-circle"
                                style="margin-right: 10px"
                            />
                            {{$t("proceedPay")}}

                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>

        </v-form>

    </div>
</template>
<script>

    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import MainMixin from "../../../mixins/mainMixin";
    import ValidatorMixin from "../../../mixins/validatorMixin";
    import {provider} from "@/service/provider";
    import axios from "axios";
    import moment from "moment";


    export default {
        name: "receivePayment",
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        data() {
            return {
                currency_symbol: "",
                valid_paid: true,

                formPayment: {
                    id: '',
                    reference: "",
                    to_contact_id: "",
                    from_contact_id: "",
                    from_contact_name: "",
                    currency_code: "",
                    note: '',
                    date: moment().format("YYYY-MM-DD"),
                    total_payment: "",
                    complete_paid: "",
                    total_amount: "",
                    paid_amount: "",
                    payment_type: 'wallet',
                    to_contact_name: "",
                    to_contact_phone: "",
                    to_contact_card_type: 'id_card',
                    to_contact_card_number: '',
                    to_contact_photo: [],
                    transaction_transfer_id: "",
                    transaction_payment_term_id: "",
                    step: "1",
                    percentage: "100",
                    duration: "0",
                    duration_type: '',
                    payment_method: 'wallet',
                    wallet_account: '',
                },

            };
        },

        methods: {
            
            reset() {
                if(this.$refs.formData){
                    this.$refs.formData.reset();
                    this.formPayment.date = '';
                    this.formPayment.paid_amount = 0;
                    this.formPayment.total_payment= 0;
                    this.formPayment.complete_paid = 0;
                    this.formPayment.total_amount= 0;
                }
            },

            handleClose(){
                this.$store.dispatch('updateTransferDialogPayment', {dialog: false, transaction_id: '', client_id: ''});
            },

            submitPayment(event, isPrint) {
                let vm = this;
                event.preventDefault();
                if (vm.$refs.formData.validate()) {
                   
                    vm.overlay = true;
                    let url = provider.baseURL + provider.storeTransferPaymentTerm;
                    return new Promise((resolve, reject) => {
                        axios.post(url, this.formPayment, {headers: {Authorization: localStorage.token}}).then(
                            res => {
                                if (res.data.response && res.data.response.code === 200) {
                                    resolve(res.data.data.payment_transaction_id);
                                    vm.$notify({
                                        title: "Success",
                                        message: vm.$t("success"),
                                        type: "success",
                                        duration: 700
                                    });
                                    vm.dialog = false;
                                    if (isPrint === true) {
                                        vm.$router.push({name: 'beeshop.agri-input.stock-transfer.stock-transfer-print', params: { id: vm.formPayment.id, transfer_status: 'forAccept'}})
                                    }
                                    vm.overlay = false;
                                    vm.$store.dispatch('updateTransferDialogPayment', {dialog: false, transaction_id: '', client_id: ''});
                                }
                                else{
                                    vm.$notify({
                                        title: "Error",
                                        message: res.data.response.message,
                                        type: "error",
                                        duration: 2000
                                    });
                                    vm.overlay = false;
                                }
                            },
                            error => {
                                reject(error);
                                vm.overlay = false;

                            }

                        );
                    });

                }
            },

        },

        watch: {
            dialogPayment(val) {
                if (val === false) { this.reset(); }
                else {
                    this.fetchCurrencyOption();
                }
            },

            async transaction_id(transaction_id){
                if(transaction_id){
                    /** Fetch the payment terms */
                    let vm = this;
                    this.formPayment.date = moment().format("YYYY-MM-DD");
                    this.overlay = true;

                    let params = {
                        search: '',
                        transaction_id: transaction_id,
                        contact_id: '',
                        due_date: '',
                        status: 'transfer',
                        offset: 0,
                        sort_by: "created_at",
                        sort_desc: 1,
                        limit: 1
                    }

                    let url = provider.baseURL + provider.getDueTransferTransactionPaymentTerm;

                    await axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(res => {
                        if (res.data.response && res.data.response.code === 200) {
                            // alter the payment
                            let data = res.data.data[0];
                            vm.id                                  = transaction_id;
                            vm.formPayment.to_contact_id           = data.from_contact_id;
                            vm.formPayment.to_contact_account_no   = data.from_contact_account_no;
                            vm.formPayment.from_contact_account_no = data.to_contact_account_no;
                            vm.formPayment.from_contact_id         = data.to_contact_id;
                            vm.formPayment.from_contact_name       = data.to_contact;
                            vm.formPayment.from_contact_type       = data.to_contact_type;
                            vm.formPayment.currency_code           = data.currency_code;
                            vm.formPayment.total_payment           = data.total_payment;
                            vm.formPayment.paid_amount             = data.total_payment;
                            vm.formPayment.total_amount            = data.total_amount;
                            vm.formPayment.complete_paid           = data.complete_paid;
                            // vm.formPayment.payment_type        = data.payment_method;
                            vm.formPayment.to_contact_name         = data.from_contact;
                            vm.formPayment.to_contact_phone        = data.from_contact_phone;
                            vm.formPayment.transaction_transfer_id = data.transaction_transfer_id;
                            vm.formPayment.transaction_payment_term_id = data.transaction_payment_term_id;
                            vm.formPayment.duration_type           = data.duration_type;
                            // vm.formPayment.payment_method      = data.payment_method;
                            vm.overlay = false;
                        }   
                    }).catch(error => {
                        vm.overlay = false;
                        console.log(error)
                    });

                    /** Fethc the waller account */
                    await this.fetchWalletByCustomer(this.formPayment.from_contact_account_no, this.formPayment.currency_code, this.formPayment.from_contact_type);
                }
            },

            "formPayment.paid_amount"(val){
                let paid_amount  = +val;
                let total_amount = this.formPayment.total_payment;
                if(paid_amount > total_amount){
                    this.valid_paid = false;
                }
                else{
                    this.valid_paid = true;
                }
            }
        },
        computed: {
            calculatePercentage(){
                let per = (+this.formPayment.total_amount - +this.formPayment.complete_paid) / (+this.formPayment.total_amount / 100);
                if(! per){ per = 0; }
                return per.toFixed(2);
            },
            dialogPayment(){
                return this.$store.state.transfer.dialog;
            },  

            transaction_id(){
                return this.$store.state.transfer.transaction_id;
            }
        },
    };
</script>
